/* global modForm */
import { showStep } from '../../../helpers';
/**
 * Check if there's a start step in the URL and switch to it
 */
export function checkStartStep() {
	if (modForm.opts.getVars.startStep && modForm.opts.getVars.startStep !== '') {
		const stepId = modForm.opts.getVars.startStep;

		if (document.getElementById(stepId)) {
			showStep(stepId);
		}
	}
}
